import { createAction, createAsyncThunk } from "@reduxjs/toolkit";

import { User } from "types/user.type";

import { AUTH_TOKEN_KEY } from "constants/common";

import * as api from "shared/api/methods";

import * as types from "./types";

export const getCurrentUser = createAsyncThunk<User, void>(
  types.GET_CURRENT_USER,
  async () => {
    const data = await api.getCurrentUser();

    const settings = await api.getUserSettingsByUserId(data.id);

    return { ...data, calculator: (settings as any).calculationValues };
  }
);

export const updateCalculationValues = createAsyncThunk<any, any>(
  types.UPDATE_CALCULATION_VALUES,
  async (data: any) => {
    
    const updatedValues = await api.updateCalculationValuesByUserId(
      data.id,
      data.calculator
    );

    return { calculator: (updatedValues as any).calculationValues };
  }
);

export const setCurrentUser = createAction<User>(types.SET_CURRENT_USER);

export const logoutUser = createAction(types.LOGOUT_USER, () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);

  return { payload: null };
});
